function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DeckTemplate = require('./deck.template');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DeckOverlay = /*#__PURE__*/function () {
  function DeckOverlay(app, mod) {
    _classCallCheck(this, DeckOverlay);
    this.app = app;
    this.mod = mod;
    this.cards = null;
    this.title = null;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(DeckOverlay, [{
    key: "render",
    value: function render() {
      if (this.mod.game.options.deck !== 'saito') {
        return;
      }
      this.overlay.show(DeckTemplate());
      console.log('- - - - - -');
      console.log('- - - - - -');
      console.log('RENDERING DECK OVERLAY');
      console.log(JSON.stringify(this.mod.game.saito_cards_added));
      console.log('- - - - - -');
      console.log('- - - - - -');
      var cardlist = '';
      if (this.mod.game.saito_cards_added.length > 0) {
        cardlist += this.mod.returnCardList(this.mod.game.saito_cards_added);
      }
      console.log('CL: ' + JSON.stringify(cardlist));

      //
      // simplify by not showing removed
      //
      //	if (this.mod.game.saito_cards_removed.length > 0) { cardlist += this.mod.returnCardList(this.mod.game.saito_cards_removed); }

      this.app.browser.addElementToSelector("<h1>New Cards: Round ".concat(this.mod.game.state.round, "</h1>"), '.deck-overlay');
      this.app.browser.addElementToSelector("<div class=\"cardlist-container\">".concat(cardlist, "</div>"), '.deck-overlay');
      var child = 0;
      for (var i = 0; i < this.mod.game.saito_cards_added.length; i++) {
        child++;
        var qs = ".deck-overlay .cardlist-container .card:nth-child(".concat(child, ")");
        if (this.mod.game.saito_cards_added_reason.length > i) {
          document.querySelector(qs).classList.add('card_added');
          this.app.browser.addElementToSelector("<div class=\"desc\">".concat(this.mod.game.saito_cards_added_reason[i], "</div>"), qs);
        }
      }
      //
      // simplify by not showing removed
      //
      //	for (let i = 0; i < this.mod.game.saito_cards_removed.length; i++) {
      //	  child++;
      //	  let qs = `.deck-overlay .cardlist-container .card:nth-child(${child})`;
      //	  if (this.mod.game.saito_cards_removed_reason.length > i) {
      //	    document.querySelector(qs).classList.add("card_removed");
      //	    this.app.browser.addElementToSelector(`<div class="desc">${this.mod.game.saito_cards_removed_reason[i]}</div>`, qs);
      //          }
      //        }

      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      document.querySelectorAll('.cardlist-container .card').forEach(function (el) {
        if (el.children.length < 4) {
          el.classList.add('custom_card_resize');
        }
        el.classList.add('noclick');
        el.onclick = function (e) {};
      });
    }
  }]);
}();
module.exports = DeckOverlay;